/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { ExtendTrialButton } from '../ExtendTrialButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  canExtendTrial: boolean;
  onClose: () => void;
  onExtendTrialClick: () => void;
  onUpgradeClick: () => void;
};

export const ZapLimitUpgradeNudge = ({
  canExtendTrial,
  onClose,
  onExtendTrialClick,
  onUpgradeClick,
}: Props) => {
  const activeView = getActiveView({
    canExtendTrial,
  });

  const secondaryButton = canExtendTrial ? (
    <ExtendTrialButton key="extend-trial" onClick={onExtendTrialClick} />
  ) : (
    <CancelButton key="cancel" onClick={onClose} />
  );

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        <UpgradeButton key="upgrade" onClick={onUpgradeClick} />,
        secondaryButton,
      ]}
      headingText="More Zaps"
      id="live-zaps"
      image={<NudgeImage type={upgradeReasons.zapLimit} />}
      subtitleText="Heads Up"
    />
  );
};
